import Container from "~/components/Container";
import Page from "~/components/Page";
import Section from "~/components/Section";
import Card from "~/components/ui/Card";
import ForgotPasswordForm from "~/components/form/ForgotPasswordForm";
import {useSearchParams} from "@solidjs/router";

export default function ForgotPasswordPage() {

    const [searchParams] = useSearchParams()

    return (
        <Page
            metaTitle="Forgot Password?"
            metaDescription="Reset your Graceful Space Yoga account password. Enter your email to receive a verification code and set a new password.">
            <Section>
                <Container>
                    <Card>
                        <div>
                            <h1>Forgot Password</h1>
                            <p>Enter your email to reset your password</p>
                            <p>You will receive an email with a code for verification</p>
                        </div>
                        <hr/>
                        <ForgotPasswordForm email={searchParams.email as string | undefined}/>
                    </Card>
                </Container>
            </Section>
        </Page>
    )
}